import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";
import {defineAsyncComponent} from "vue";
import { customAsyncComponent } from "@/functions/customAsyncComponent";
import { LOCALE_CATEGORIES } from "@/assets/locales/categories";
import { PageHeaderConfig } from "@/components/navigation/usePageHeader";
import { i18n } from "@/i18n";
import router from "@/router";
import sdk, { WorkspaceId } from "@/sdk";

export function getCollectiveToolsLandingRouteRecord():RouteRecordRaw{
  return {
    name: 'collective-tools-landing',
    path: '/workspace/:workspaceId/collective-tools/presentation',
    component: customAsyncComponent(async () => import('./views/CollectiveToolsLandingView.vue')),
    meta: {
      navLoader: true,
      hasNav: true,
      forceMe: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.NAVIGATION,
        LOCALE_CATEGORIES.GROUP_TOOLS
      ]
    }
  }
}

export function getCollectiveToolsLandingRouteLocation(workspaceId: number):RouteLocationRaw{
  return { name: 'collective-tools-landing', params:{workspaceId} }
}

export function getCollectiveToolsLandingRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}

export function getCollectiveToolsLandingPageHeaderConfig(): PageHeaderConfig{
  return {
    showHome: false,
    showTitle: false,
    title: '',
    breadcrumb: []
  }
}


export function getCollectiveToolsListRouteRecord():RouteRecordRaw{
  return {
    name: 'collective-tools-list',
    path: '/workspace/:workspaceId/collective-tools',
    component: customAsyncComponent(async () => import('./views/CollectiveToolsListView.vue')),
    meta: {
      navLoader: true,
      hasNav: true,
      forceMe: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.NAVIGATION,
        LOCALE_CATEGORIES.GROUP_TOOLS,
        LOCALE_CATEGORIES.JOURNEY
      ]
    }
  }
}

export function getCollectiveToolsListRouteLocation(workspaceId: number):RouteLocationRaw{
  return { name: 'collective-tools-list', params:{workspaceId} }
}

export function getCollectiveToolsListRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}

export function getCollectiveToolsListPageHeaderConfig(): PageHeaderConfig{
  return {
    showHome: false,
    showTitle: true,
    title: i18n.global.t('group_tools.list.header'),
    breadcrumb: []
  }
}


/* export function getCollectiveToolsRouteRecord():RouteRecordRaw{
  return {
    name: 'collective-tools',
    path: '/workspace/:workspaceId/collective-tools',
    meta: {
      navLoader: true,
      hasNav: true,
      forceMe: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.NAVIGATION,
        LOCALE_CATEGORIES.GROUP_TOOLS
      ]
    }
  }
}

export function getCollectiveToolsRouteLocation(workspaceId: number):RouteLocationRaw{
  return { name: 'collective-tools', params:{workspaceId} }
}

export function getCollectiveToolsRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
} */